import * as layouts from "./index";
import React from "react";
import { PageProps } from "@/getServerSideProps/getServerSideProps";

type Layout = (props: PageProps) => React.ReactNode;

export const layoutMap: { [name: string]: Layout } = layouts;
